export default __webpack_public_path__ + "static/media/mod02.c1666745.svg";